export enum IntendedState {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED'
}
